import {SvgIconData} from '@shared_web/components/core/svg_icon';

import {ORANGE_COLOR} from '@mavismart_frontend/lib/constants';

export const icon_warning_orange: SvgIconData = {
  viewBox: '0 0 29 29',
  element: (
    <path
      d="M14.5 8.66667V14.5M14.5 20.3333H14.5146M27.625 14.5C27.625 21.7487 21.7487 27.625 14.5 27.625C7.25126 27.625 1.375 21.7487 1.375 14.5C1.375 7.25126 7.25126 1.375 14.5 1.375C21.7487 1.375 27.625 7.25126 27.625 14.5Z"
      stroke={ORANGE_COLOR}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
};
